export default "__VITE_ASSET__BZImdxkx__"